import { useEffect, useState } from "react";
import { WaveformBars } from "../chat/WaveformBars";
import { formatDuration, isVideoFilename } from "../../../utils";

export type PendingMedia =
  | { kind: "image" | "video"; file: File }
  | { kind: "voice"; file: File; durationSec: number; waveform: number[] };

// Replaces SendGiftScreen.tsx's old ad hoc image/video-only preview block -
// photo/video/voice each get their own rendering (voice gets a real
// waveform card, not an empty image box). Rounded-rectangle frame per the
// brief's explicit instruction, NOT the heart crop the reveal viewer uses
// (that stays reveal-only ceremony, not composition-time chrome).
export function GiftMediaPreview({ media, onChange }: { media: PendingMedia; onChange: () => void }) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    const objectUrl = URL.createObjectURL(media.file);
    setUrl(objectUrl);
    return () => URL.revokeObjectURL(objectUrl);
  }, [media.file]);

  if (!url) return null;

  if (media.kind === "voice") {
    return (
      <div className="private-drop-preview private-drop-preview-voice">
        <div className="private-drop-preview-voice-card">
          <i className="bi bi-mic-fill" aria-hidden="true" />
          <WaveformBars levels={media.waveform} />
          <span className="private-drop-preview-voice-duration">{formatDuration(media.durationSec)}</span>
        </div>
        <button type="button" className="send-gift-preview-change" onClick={onChange}>
          Change
        </button>
      </div>
    );
  }

  const isVideo = media.kind === "video" || isVideoFilename(media.file.name);
  return (
    <div className="send-gift-preview">
      {isVideo ? (
        <video src={url} muted playsInline controls className="send-gift-preview-media" style={{ borderRadius: 20 }} />
      ) : (
        <img src={url} alt="Drop preview" className="send-gift-preview-media" style={{ borderRadius: 20 }} />
      )}
      <button type="button" className="send-gift-preview-change" onClick={onChange}>
        Change
      </button>
    </div>
  );
}
